import { Box, CircularProgress, Divider, Icon, Link, Typography } from '@mui/material'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import React, { useEffect, useState } from 'react'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { useQuery } from 'react-query'
import { getSample } from 'services/api/modules/recruitment/external-talent'
import { downloadBlobFile, notifyDownloadError } from 'services/helper/fileDownload'

const sample_data = [
  {
    sample_id: 3,
    name: 'Ahmad Hashim bin Abdul Haji',
    email: 'ahmad.hashim@gmail.com',
    details: [
      {
        name: 'Ahmad Hashim bin Abdul Haji',
        email: 'ahmad.hashim@gmail.com',
        mobile: '012-3456789',
        linkedin: null,
      },
    ],
    skills: ['UX Design', 'Figma', 'Adobe XD'],
    work_experiences: [
      {
        position: 'Lead UIUX Designer',
        company: 'Agensi Pekerjaan adnexio Sdn Bhd',
        duration: '09/2020 - Present (2 yrs)',
        salary: 'RM 4,500',
        job_description:
          'Lead the UIUX implementation of ongoing products and mentor a team of UI/UX designers by providing guidance, feedback, and fostering a culture of creativity and collaboration. Design and establish the overall concept, flow, feel and look of websites and mobile apps with high quality user interfaces, experience design and consistent branding',
      },
    ],
    education_data: [
      {
        title: 'Bachelor Degree in Multimedia Design',
        tenure: '2016 - 2020',
        college: 'University of Technology Petronas',
      },
    ],
    score_data: [
      {
        icon: 'school',
        title: 'Academic',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 3.5,
      },
      {
        icon: 'work',
        title: 'Experience',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 3.5,
      },
      {
        icon: 'emoji_events',
        title: 'Extracurricular',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 1,
      },
      {
        icon: 'video_camera_front_rounded',
        title: 'Video interview',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 0,
      },
      {
        icon: 'groups',
        title: 'Leadership',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 4.5,
      },
    ],
  },

  {
    sample_id: 1,
    name: 'Amirah Hassan',
    email: 'amirah@adxsample.com',
    details: [
      {
        name: 'Amirah Hassan',
        email: 'amirah@adxsample.com',
        mobile: '012-3456789',
        linkedin: null,
      },
    ],
    skills: ['Javascript', 'React Native', 'Mobile Development'],
    work_experiences: [
      {
        position: 'Senior software engineer',
        company: 'Agensi Pekerjaan adnexio Sdn Bhd ',
        duration: '09/2020 - Present (3 yrs) ',
        salary: 'RM 4,500',
        job_description:
          'Design, develop, test, and maintain software solutions, ensuring they meet performance, quality, and security standards. Collaborate with product managers, designers, and other engineers to define software requirements and specifications.',
      },
    ],
    education_data: [
      {
        title: 'Bachelor degree in Information Technology',
        tenure: '2017 - 2020',
        college: 'University of Technology ',
      },
    ],
    score: '4.2',
    score_data: [
      {
        icon: 'school',
        title: 'Academic',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 4.5,
      },
      {
        icon: 'work',
        title: 'Experience',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 5.0,
      },
      {
        icon: 'emoji_events',
        title: 'Extracurricular',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 2,
      },
      {
        icon: 'video_camera_front_rounded',
        title: 'Video interview',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 0,
      },
      {
        icon: 'groups',
        title: 'Leadership',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 4.5,
      },
    ],
  },
  {
    sample_id: 2,
    name: 'Farah Liyana Binti Tan',
    email: 'farah@adxsample.com',
    details: [
      {
        name: 'Farah Liyana Binti Tan',
        email: 'farah@adxsample.com',
        mobile: '012-3456789',
        linkedin: null,
      },
    ],
    skills: ['Client Servicing', 'Business analyst', 'Growth Hacking'],
    work_experiences: [
      {
        position: 'Product Manager',
        company: 'Agensi Pekerjaan adnexio Sdn Bhd',
        duration: '09/2020 - Present (2 yrs)',
        salary: 'RM 4,500',
        job_description:
          'Define and communicate the product vision, strategy, and roadmap based on market research, customer feedback, and business goals. Collaborate with stakeholders to gather and prioritize product requirements, creating clear and actionable user stories. Work closely with engineering and design teams to develop and launch high-quality products, ensuring they align with the defined vision and strategy.',
      },
    ],
    education_data: [
      {
        title: 'Bachelor degree in Mass communication',
        tenure: '2016 - 2019',
        college: 'University of Technology Petronas',
      },
    ],
    score_data: [
      {
        icon: 'school',
        title: 'Academic',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 3.5,
      },
      {
        icon: 'work',
        title: 'Experience',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 3.5,
      },
      {
        icon: 'emoji_events',
        title: 'Extracurricular',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 1,
      },
      {
        icon: 'video_camera_front_rounded',
        title: 'Video interview',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 0,
      },
      {
        icon: 'groups',
        title: 'Leadership',
        description:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates doloremque blanditiis, odit, adipisci dicta at possimus.',
        score: 4.5,
      },
    ],
  },
]

const SampleDataDrawer = ({ sampleId }) => {
  const [drawerState, setDrawerState] = useState({ right: false })
  const [isDownloading, setIsDownloading] = useState(false)

  const { data, refetch, isLoading, isFetching } = useQuery(
    'getSample',
    async () => {
      const { data } = await getSample(sampleId)
      return data
    },
    {
      refetchOnWindowFocus: false,
      enabled: drawerState.right,
    }
  )

  useEffect(async () => {
    if (sampleId && drawerState.right) {
      await refetch()
    }
  }, [drawerState.right])

  const handleDrawer = (anchor, open) => () => {
    setDrawerState({ ...drawerState, [anchor]: open })
  }

  const handleDownload = (fileURL, fileName = 'resume') => {
    const renamedFile = fileName.replace(/[ '"`]/g, '_').toLowerCase()

    setIsDownloading(true)
    fetch(fileURL)
      .then((response) => response.blob())
      .then((blob) => {
        const contentType = blob.type || 'application/octet-stream'
        downloadBlobFile({
          data: blob,
          fileName: renamedFile,
          contentType,
          successMessage: 'Sample file downloaded.',
        })
        setIsDownloading(false)
      })
      .catch((error) => {
        console.error('Error downloading the file:', error)
        notifyDownloadError('Unable to download sample file. Please try again.')
        setIsDownloading(false)
      })
  }

  const selectedSampleData = sample_data.find((data) => data.sample_id === sampleId)

  const { name, email, details, skills, work_experiences, education_data, score_data } =
    selectedSampleData

  return (
    <Box>
      <Typography
        onClick={handleDrawer('right', true)}
        sx={{ color: 'alternate.main', textDecoration: 'underline', cursor: 'pointer' }}
      >
        View
      </Typography>
      <AdxDrawerComponent
        state={drawerState}
        anchor="right"
        onClose={handleDrawer}
        sx={{ padding: 0 }}
        sxIcon={{ marginRight: '30px' }}
        headerprops={
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography sx={{ marginLeft: '30px', marginY: '15px', fontWeight: 'bold' }}>
              Talent
            </Typography>
          </Box>
        }
      >
        <Divider />
        <Box sx={{ padding: '30px', display: 'flex', alignItems: 'center', gap: '20px' }}>
          <Box
            sx={{
              width: '65px',
              height: '65px',
              backgroundColor: 'default-background.main',
              borderRadius: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Icon sx={{ fontSize: '36px', color: 'alternate.main' }}>person_outline</Icon>
          </Box>
          <Box sx={{ width: 'calc(100% - 80px)' }}>
            <Typography variant="h4">{name}</Typography>
            <Typography sx={{ color: 'light-gray-text.main' }}>{email}</Typography>
          </Box>
        </Box>
        <AdxTabsBadge
          initialValue={0}
          sxPanel={{ borderRadius: 0, borderTop: '1px solid #E5E5E5' }}
        >
          <AdxTabsPanel label="Resume">
            <Box sx={{ padding: '30px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ color: 'light-gray-text.main' }}>
                  Uploaded on 18/10/2022, 10:30 AM
                </Typography>
                {isDownloading ? (
                  <CircularProgress color="alternate" size={20} />
                ) : (
                  <FileDownloadOutlinedIcon
                    onClick={() => handleDownload(data?.url, name)}
                    sx={{ fontSize: '24px', color: 'alternate.main', cursor: 'pointer' }}
                  />
                )}
              </Box>
              {isLoading || isFetching ? (
                <Box
                  sx={{
                    width: '100%',
                    height: '50vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <CircularProgress sx={{ fontSize: '20px', color: 'alternate.main' }} />
                </Box>
              ) : (
                <Box sx={{ borderRadius: '4.5px', overflow: 'clip', border: '1px solid #E5E5E5' }}>
                  <Box
                    sx={{
                      height: '200px',
                      backgroundColor: 'default-background.main',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Icon sx={{ color: 'alternate.main', fontSize: '34px' }}>description</Icon>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '16px',
                      borderTop: '1px solid #E5E5E5',
                    }}
                  >
                    <Box>
                      <Typography>{name.replace(/[ '"`]/g, '_').toLowerCase()}.pdf</Typography>
                      <Typography variant="subtitle2" sx={{ color: 'light-gray-text.main' }}>
                        23.3 mb
                      </Typography>
                    </Box>
                    <Link
                      target="_blank"
                      href={data?.url}
                      sx={{ color: 'alternate.main', textDecoration: 'underline' }}
                    >
                      View
                    </Link>
                  </Box>
                </Box>
              )}
            </Box>
          </AdxTabsPanel>

          <AdxTabsPanel label="Details">
            <Box sx={{ padding: '30px' }}>
              <Typography sx={{ marginBottom: '18.5px', fontWeight: 'bold' }}>Details</Typography>
              {details.map((i, index) => (
                <Box key={index} sx={{ display: 'flex', gap: '14px', marginBottom: '48.5px' }}>
                  <Box
                    sx={{
                      width: '150px',
                      color: 'light-gray-text.main',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                    }}
                  >
                    <Typography>Name</Typography>
                    <Typography>Email</Typography>
                    <Typography>Contact number</Typography>
                    <Typography>LinkedIn</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <Typography>{i.name}</Typography>
                    <Typography>{i.email}</Typography>
                    <Typography>{i.mobile}</Typography>
                    <Typography>{i.linkedin}</Typography>
                  </Box>
                </Box>
              ))}
              <Typography sx={{ marginBottom: '18.5px', fontWeight: 'bold' }}>Skills</Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                {skills.map((i, index) => (
                  <Box
                    key={index}
                    sx={{
                      borderRadius: '4.5px',
                      backgroundColor: 'default-background.main',
                      padding: '12px',
                    }}
                  >
                    {i}
                  </Box>
                ))}
              </Box>
            </Box>
          </AdxTabsPanel>

          <AdxTabsPanel label="Work experience">
            {work_experiences.map((i, index) => (
              <Box key={index} sx={{ padding: '30px', borderTop: '1px solid #E5E5E5' }}>
                <Typography sx={{ marginBottom: '20px', fontWeight: 'bold' }}>
                  {i.position}
                </Typography>
                <Box sx={{ display: 'flex', gap: '14px', marginBottom: '10px' }}>
                  <Box
                    sx={{
                      width: '150px',
                      color: 'light-gray-text.main',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                    }}
                  >
                    <Typography>Company </Typography>
                    <Typography>Duration </Typography>
                    <Typography>Salary </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <Typography>{i.company}</Typography>
                    <Typography>{i.duration}</Typography>
                    <Typography>{i.salary}</Typography>
                  </Box>
                </Box>
                <Typography sx={{ color: 'light-gray-text.main' }}>Job description</Typography>
                <Typography>{i.job_description}</Typography>
              </Box>
            ))}
          </AdxTabsPanel>

          <AdxTabsPanel label="Education">
            {education_data.map((i, index) => (
              <Box key={index} sx={{ padding: '30px', borderTop: '1px solid #E5E5E5' }}>
                <Typography sx={{ marginBottom: '20px', fontWeight: 'bold' }}>
                  {education_data.title}
                </Typography>
                <Box sx={{ display: 'flex', gap: '14px' }}>
                  <Box
                    sx={{
                      width: '150px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                      color: 'light-gray-text.main',
                    }}
                  >
                    <Typography>Tenure </Typography>
                    <Typography>College </Typography>
                  </Box>
                  <Box
                    sx={{ width: '150px', display: 'flex', flexDirection: 'column', gap: '10px' }}
                  >
                    <Typography>{i.tenure}</Typography>
                    <Typography>{i.college}</Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </AdxTabsPanel>

          <AdxTabsPanel label="Score">
            <Box
              sx={{
                position: 'relative',
                padding: '40px 30px 30px 30px',
                display: 'flex',
                flexDirection: 'column',
                gap: '42px',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  left: 0,
                  top: '120px',
                  width: '100%',
                  height: '263px',
                  opacity: 0.8,
                  backgroundImage: 'linear-gradient(to bottom, #09A3A9, white)',
                }}
              />
              <Box
                sx={{
                  width: '100%',
                  height: '20px',
                  backgroundColor: 'white.main',
                  position: 'absolute',
                  top: '120px',
                  left: 0,
                  borderRadius: '0 0 100% 100%',
                }}
              />
              <Box
                sx={{
                  position: 'relative',
                  zIndex: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                  2.6
                </Typography>
                <Typography sx={{ color: 'light-gray-text.main', marginBottom: '16px' }}>
                  Profile score
                </Typography>
                <Box
                  sx={{
                    borderRadius: '100%',
                    width: '65px',
                    height: '65px',
                    backgroundColor: 'default-background.main',
                    border: '1px solid #E5E5E5',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Icon sx={{ color: 'yellow-01.main', fontSize: '36px' }}>stars_rounded</Icon>
                </Box>
              </Box>
              <Box
                sx={{
                  position: 'relative',
                  zIndex: 2,
                  borderRadius: '4.5px',
                  border: '1px solid #E5E5E5',
                  backgroundColor: 'white.main',
                }}
              >
                {score_data.map((i, index) => (
                  <Box
                    key={index}
                    sx={{
                      padding: '16px',
                      display: 'flex',
                      gap: '16px',
                      borderTop: index === 0 ? 'none' : '1px solid #E5E5E5',
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: '100%',
                        width: '35px',
                        height: '35px',
                        backgroundColor: 'default-background.main',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Icon sx={{ fontSize: '20px', color: 'alternate.main' }}>{i.icon}</Icon>
                    </Box>
                    <Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: '15px',
                        }}
                      >
                        <Typography sx={{ fontWeight: 'bold' }}>{i.title}</Typography>
                        <Box
                          sx={{
                            width: '50px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <Icon sx={{ color: 'yellow-01.main', fontSize: '20px' }}>
                            stars_rounded
                          </Icon>
                          <Typography sx={{ fontWeight: 'bold' }}>{i.score.toFixed(1)}</Typography>
                        </Box>
                      </Box>
                      <Typography sx={{ color: 'light-gray-text.main' }}>
                        {i.description}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </AdxTabsPanel>
        </AdxTabsBadge>
      </AdxDrawerComponent>
    </Box>
  )
}

export default SampleDataDrawer
